import React from 'react';
import './empty.scss';
import PropTypes from 'prop-types';
import Icon from '../../mweb/Icon/Icon';
import { Link } from 'react-router-dom';

const Empty = props => {
  const {
    icon = 'icon-cart-empty-cart',
    iconSize = 142,
    title,
    message,
    ctaText,
    ctaLink,
  } = props;
  return (
    <div className="empty">
      <div className="empty--icon">
        <Icon class={icon} size={iconSize} />
      </div>
      {title && <div className="empty--oops">{title}</div>}
      {message && <div className="empty--msg">{message}</div>}
      {ctaText && ctaLink && (
        <div className="empty--cta">
          <Link to={ctaLink} className="button button-primary full-width">
            {ctaText}
          </Link>
        </div>
      )}
    </div>
  );
};

Empty.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
};

export default Empty;
